import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { LogIn, MapPin } from 'lucide-react';
import { adminApi, isAdminAuthed } from '../../api';

export default function AdminLogin() {
  const [email, setEmail] = useState('admin@yup.com');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    document.body.classList.add('admin-body');
    return () => document.body.classList.remove('admin-body');
  }, []);

  if (isAdminAuthed()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const res = await adminApi.login(email, password);
      localStorage.setItem('yup_admin_token', res.access_token);
      nav('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login fallito');
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-scope min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f2a44] to-[#1a3a5c] px-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-lg bg-[color:var(--yup-primary)] flex items-center justify-center text-white"><MapPin size={22} /></div>
          <div>
            <h1 className="text-xl font-bold text-[color:var(--yup-primary)]">YUP Admin</h1>
            <p className="text-xs text-gray-500">Pannello di controllo</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[color:var(--yup-primary)] focus:ring-2 focus:ring-[color:var(--yup-primary)]/20" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[color:var(--yup-primary)] focus:ring-2 focus:ring-[color:var(--yup-primary)]/20" />
          </div>
          {error && <div className="text-red-600 text-sm bg-red-50 border border-red-200 px-3 py-2 rounded">{error}</div>}
          <button type="submit" disabled={loading} className="w-full btn-primary flex items-center justify-center gap-2 disabled:opacity-60">
            <LogIn size={16} /> {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
        <p className="text-xs text-gray-400 text-center mt-6">YUP CMS • v1.0</p>
      </div>
    </div>
  );
}
